import React from "react";
import LegalLayout from "@/pages/LegalLayout";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-4">
      {title}
    </h2>
    <div className="text-neutral-300 text-sm md:text-base leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const Cookies = () => {
  return (
    <LegalLayout
      title="Çerez Politikası"
      subtitle="MoDuLerİS web sitesinde kullanılan çerezler ve amaçları hakkında bilgi."
    >
      <Section title="1. Çerez Nedir?">
        <p>
          Çerez (cookie), bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla
          cihazınıza yerleştirilen küçük bir metin dosyasıdır. Çerezler, ziyaretinizin daha
          verimli olması ve tercihlerinizin hatırlanması amacıyla kullanılır.
        </p>
      </Section>

      <Section title="2. Kullandığımız Çerez Türleri">
        <p>Web sitemizde aşağıdaki çerez türleri kullanılmaktadır:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong className="text-white">Zorunlu Çerezler:</strong> Sitenin temel işlevleri için gereklidir; kapatılamaz.
          </li>
          <li>
            <strong className="text-white">Performans Çerezleri:</strong> Ziyaretçilerin siteyi nasıl kullandığını anonim olarak ölçmemize yardımcı olur.
          </li>
          <li>
            <strong className="text-white">İşlevsellik Çerezleri:</strong> Dil tercihi gibi seçimlerinizi hatırlar.
          </li>
        </ul>
      </Section>

      <Section title="3. Üçüncü Taraf Çerezleri">
        <p>
          Web sitemiz, harita gösterimi için OpenStreetMap ve font yükleme için Google Fonts
          hizmetlerini kullanmaktadır. Bu servislerin kendi çerez politikaları geçerlidir.
        </p>
      </Section>

      <Section title="4. Çerezleri Yönetme">
        <p>
          Çerezleri tarayıcınızın ayarlarından yönetebilir, engelleyebilir veya silebilirsiniz.
          Ancak zorunlu çerezleri engellemeniz durumunda sitenin bazı işlevlerinden
          faydalanamayabilirsiniz.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Google Chrome: Ayarlar → Gizlilik ve Güvenlik → Çerezler</li>
          <li>Safari: Tercihler → Gizlilik → Çerezler</li>
          <li>Firefox: Seçenekler → Gizlilik ve Güvenlik → Çerezler</li>
        </ul>
      </Section>

      <Section title="5. İletişim">
        <p>
          Çerezler ile ilgili sorularınızı{" "}
          <a href="mailto:moduleris@gmail.com" className="text-[#ff5a00] hover:underline">
            moduleris@gmail.com
          </a>{" "}
          adresine iletebilirsiniz.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default Cookies;
